import { combineReducers } from 'redux';
import * as actionTypes from '../action-mgr/actionTypes';

const selectedStationName = (state = "", action) => {
    switch (action.type) {
      case actionTypes.SET_SELECTED_STATION_NAMES:
        return action.stationName;
      default:
        return state;
    }
}

const currentDownloadConfigStation = (state = "", action) => {
  switch (action.type) {
    case actionTypes.CURRENT_DOWNLOAD_CONFIG_STATION:
      return action.stationName;
    default:
      return state;
  }
}

const downloadConfigListObject = (state = [], action) => {
    switch (action.type) {
      case actionTypes.LIST_DOWNLOAD_CONFIG_OBJECT:
        return {
          ...state,
          downloadConfigList: action.data, 
        };
      default:
        return state;
    }
  };

  export default combineReducers({
    selectedStationName,
    currentDownloadConfigStation,
    downloadConfigListObject
  });

const getCurrentState = state => state.downloadRequests.downloadConfig;
export const getSelectedStationName = state => getCurrentState(state).selectedStationName;
export const getCurrentDownloadConfigStation = state => getCurrentState(state).currentDownloadConfigStation;

export const listDownloadConfigObject = state => getCurrentState(state).downloadConfigListObject;

